<div class="w-full h-full flex justify-content-center">
  <div class="flex flex-column step-content">
    <div class="display-sm-semibold text-gray-900">Izaberite tip naloga</div>
    <div class="mt-2-5 text-md-regular text-gray-600">Izaberite da li se registrujete kao pravno ili fizičko lice.</div>
    <div class="mt-5 flex flex-column md:flex-row gap-3 md:gap-0">
      <div class="flex flex-column align-items-center justify-content-center cursor-pointer entity-card"
           [class.selected]="form().value.isLegalEntity"
           (click)="selectType(true)">
        <div class="entity-card__check">
          <p-checkbox [binary]="true"
                      [ngModel]="form().value.isLegalEntity"
                      [ngModelOptions]="{ standalone: true }"
                      (click)="$event.preventDefault()"
                      [dt]="checkboxStyle" />
        </div>
        <div class="icon">
          <app-building-05 stroke="#414651" width="28px" height="28px"></app-building-05>
        </div>
        <div class="mt-3 text-md-semibold text-gray-900">Pravno lice</div>
      </div>
      <div class="md:ml-4 flex flex-column align-items-center justify-content-center cursor-pointer entity-card"
           [class.selected]="!form().value.isLegalEntity"
           (click)="selectType(false)">
        <div class="entity-card__check">
          <p-checkbox [binary]="true"
                      [ngModel]="!form().value.isLegalEntity"
                      [ngModelOptions]="{ standalone: true }"
                      (click)="$event.preventDefault()"
                      [dt]="checkboxStyle" />
        </div>
        <div class="icon">
          <app-user-circle stroke="#414651" width="28px" height="28px"></app-user-circle>
        </div>
        <div class="mt-3 text-md-semibold text-gray-900">Fizičko lice</div>
      </div>
    </div>
    <div class="mt-4 flex justify-content-end">
      <app-button [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="next.emit()">
        <div class="text-sm-semibold text-white">Nastavi</div>
        <app-arrow stroke="white" direction="right"></app-arrow>
      </app-button>
    </div>
  </div>
</div>
